import React from "react";
import { useLoadout } from "@/lib/loadouts";

/**
 * <BlingUsername username={...} defaultColor="#..." onClick={...} testid={...} />
 *
 * Renders a chat username with the equipped `chat_color` bling applied.
 * Solid colors use `color`. Gradient values (`linear-gradient(...)`) are
 * applied via `background-clip: text` so the text glyphs are gradient-filled.
 *
 * Falls back to `defaultColor` (e.g., the message's server-assigned color)
 * when the user hasn't equipped a chat_color.
 */
export default function BlingUsername({
  username,
  defaultColor,
  onClick,
  className = "",
  testid,
  suffix = ":",
}) {
  const loadout = useLoadout(username);
  const cc = loadout?.chat_color?.value;
  const isGradient = typeof cc === "string" && cc.includes("gradient");

  const style = isGradient
    ? {
        backgroundImage: cc,
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        color: "transparent",
        WebkitTextFillColor: "transparent",
      }
    : { color: cc || defaultColor || "#FF1053" };

  const Comp = onClick ? "button" : "span";
  return (
    <Comp
      onClick={onClick}
      style={style}
      className={`font-bold mr-1.5 ${onClick ? "hover:underline" : ""} ${className}`}
      data-testid={testid}
    >
      {username}{suffix}
    </Comp>
  );
}
